import React from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import StatCard from '../components/StatCard';
import ODFlowPanel from '../components/ODFlowPanel';
import FlowMap from '../components/FlowMap';
import { IconFlow, IconPulse, IconPin } from '../components/icons';

const compact = (n) => new Intl.NumberFormat('fr-FR', { notation: 'compact', maximumFractionDigits: 1 }).format(n);

export default function ODFlows() {
  const { loading, data, live } = useApi(() => api.odFlows());
  const flows = data?.flows || [];
  const total = flows.reduce((a, f) => a + f.volume, 0);
  const top = [...flows].sort((a, b) => b.volume - a.volume)[0];
  const nameOf = (id) => data?.zones?.find((z) => z.id === id)?.nom || id;

  return (
    <>
      <Topbar title="Cartographie origine-destination" subtitle="Flux de déplacements entre arrondissements — région de Dakar" live={live} />
      <div className="content">
        {loading ? <div className="loading-screen">Chargement de la carte…</div> : (
          <>
            <div className="kpi-row kpi-row--3">
              <StatCard label="Déplacements / an" value={compact(total)} icon={IconPulse} delay={0} />
              <StatCard label="Corridors cartographiés" value={String(flows.length)} icon={IconFlow} delay={70} />
              <StatCard label="Corridor n°1" value={top ? compact(top.volume) : '—'} icon={IconPin} trend={top ? { dir: 'flat', text: `${nameOf(top.origin)} → ${nameOf(top.destination)}` } : null} delay={140} />
            </div>

            {/* Carte interactive (élément principal) */}
            <div className="mapcard reveal" style={{ animationDelay: '120ms' }}>
              <div className="mapcard__head">
                <div className="panel__title">
                  <span className="ic"><IconFlow /></span>
                  <div>
                    <h3>Carte des flux</h3>
                    <div className="panel__sub">Points = arrondissements (taille ∝ activité) · arcs = corridors (épaisseur ∝ volume)</div>
                  </div>
                </div>
                <span className="panel__badge">{data?.source === 'd4d' ? 'Données réelles D4D' : 'Démo'}</span>
              </div>
              <div className="mapcard__map">
                <FlowMap data={data} />
                <div className="map-legend">
                  <div><span className="dot" style={{ background: '#10b981' }} /> Arrondissement</div>
                  <div><span className="line" /> Corridor (flux)</div>
                </div>
              </div>
            </div>

            {/* Détail des corridors (secondaire) */}
            <div style={{ marginTop: 18 }}>
              <ODFlowPanel data={data} delay={200} />
            </div>
          </>
        )}
      </div>
    </>
  );
}
